export const isFontAwesomeIcon = (href) => /^fa:/.test(href)
export const isFontAwesomeBrandIcon = (href) => /stripe\w*/.test(href)
export const getFontAwesomeIconClass = (href) => isFontAwesomeIcon(href) ? `${isFontAwesomeBrandIcon(href) ? "fab" : "fa"} ${href.replace(/:/, "-")}` : undefined
